import React, { Component, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { applyDataTable } from '../../custom/dataTable';
import save from '../../../assets/img/svg/saveIcon.svg';
import cancel from '../../../assets/img/svg/cancelIcon.svg';
import deleteIcon from '../../../assets/img/svg/delete.svg';
import upload from '../../../assets/img/svg/upload.svg';
import desc from '../../../assets/img/svg/desc.svg';
// import Dropzone from "react-dropzone";
import { TextField } from "@material-ui/core"
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import del from '../../../assets/img/svg/Del.svg';
import $ from 'jquery';
import { Tabs, Tab, AppBar, Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from "../../../assets/jss/customStyle";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import { addshipdocumentinfo } from "../../../actions/ShipDocumentAction"
// import EditOPA_Historylog from '../DailyTasks/OperationPlanningAchievements/EditOPA-Historylog';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}


const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: "none !important"
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
        padding: "5px 10px"
    },
    fontIcon: {
        paddingRight: "8px",
    },
    indicator: {
        backgroundColor: "#00838F",
    },
}));

class UploadFile extends Component {
    constructor(props) {
        super(props)
        this.inputFile = React.createRef();
        this.state = {
            ProjectId: 0,
            Docs: [],
            data: [],
            hide: [],
        }
    }

    AttachFiles = () => {
        this.inputFile.current.click();
    };

    // progressStyle = () => {
    // const width = 1;
    // if (width >= 100) {
    //     clearInterval(id);
    //   } else {
    //     width++; 
    //     $(".progress-bar").css("width", i + "%").text(i + "%");
    //   }
    // }

    UploadFile = (e) => {
        var filesize = "";
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                fileName: a.name,
                size: a.size,
                check: false,
                fdata: a,
            }
            filesize = a.size;
            this.state.Docs.push(upload)
            this.state.data.push(a)
            this.setState({})
        })
        var el = this.state.Docs.length;
        var width = 1;
        var id = setInterval(frame, 10);
        // var ids = setInterval(size, 10);
        function frame() {
            if (width >= 100) {
                clearInterval(id);
                document.getElementById( el + "uploading").innerHTML="100% Complete"
                document.getElementById( el + "size").innerHTML=(filesize / 1048576).toFixed(2) +"MB of "+ (filesize / 1048576).toFixed(2) +"MB"
            } else {
                width++;
                $('#'+el).css("width", width + "%")
                document.getElementById( el + "uploading").innerHTML="Uploading...."+width + "%"
                document.getElementById( el + "size").innerHTML= width/100 +"MB of "+ (filesize / 1048576).toFixed(2) +"MB"
            }
        }
        // function size() {
        //     let val = (filesize / 1048576).toFixed(2);
        //     let width = (0).toFixed(2)
        //     if (width >= val) { 
        //         clearInterval(ids);
        //         document.getElementById( el + "size").innerHTML=(filesize / 1048576).toFixed(2) +"MB of "+ (filesize / 1048576).toFixed(2) +"MB"
        //     } else {
        //         width = parseFloat(width) + parseFloat(0.01) ;
        //         document.getElementById( el + "size").innerHTML= width  +"MB of "+ (filesize / 1048576).toFixed(2) +"MB"
        //         width = parseFloat(width) + parseFloat(0.01) ;
        //     }
        // }
        this.props.dispatch({ type: "UPLOAD_DOCS", data: this.state.Docs })
    };

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        this.state.Docs = this.props.uploaddocs;
        this.setState({})
        this.props.dispatch({type:"SAVE_SHIPDOC",data:this.state.Docs})
        // this.state.ProjectId = localStorage.getItem("DashId");
        // this.setState({})
    };

    componentDidMount() {
        applyDataTable("staffTable");
        $("#Documents1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Documents").removeClass("d-none");
        $("#Documents").addClass("d-block");
        this.props.dispatch({ type: "UPLOAD_DOCS", data: [] })
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    };


    componentWillUnmount() {
        clearInterval(this.interval);
    }

    setCheckbox = (str) => {
        this.state.Docs.map((i) => {
            if (str == i.fileName) {
                i.check = !i.check;
                this.setState({});
            }
        })
        let idfilter = this.state.Docs.filter(val => val.check == true)
        this.state.hide = idfilter;
        this.setState({})
        this.props.dispatch({type:"HIDE_SHIPDEL",data:this.state.hide})
     
    };

    render() {
        let { classes, projectStatus, menuToggle } = this.props;
        return (
            <>
                <div className="text-center">
                    <div className="py-5" style={{ border: "1px dashed #E7E7E7", height: 300 }}
                    //  onDragOver={(e) => onDragOver(e)} onDragLeave={(e) => onDragLeave(e)} onDrop={(e) => onDrop(e)}
                    >
                        <div className="py-5">
                            <img src={upload}></img>
                            <div>Drag and drop or <u onChange={(e) => this.UploadFile(e)} style={{ color: "#00838F", cursor: "pointer" }} onClick={this.AttachFiles}>browse</u> your file</div>
                        </div>
                        <input
                            type="file"
                            hidden
                            multiple
                            onChange={(e) => this.UploadFile(e)}
                            ref={this.inputFile}
                        />
                    </div>
                </div>
                <div className="my-3">
                    {this.state.Docs.map((m, i) => (
                        <div className="py-2">
                            <div className="row">
                                <div className="col-4 col-xl-1 col-md-2 col-lg-2 col-sm-3 my-auto">
                                    <span className="row">
                                        <span className="col-4 mt-2">
                                            <label class="contCheck">
                                                <input type="checkbox" checked={m.check} onChange={() => this.setCheckbox(m.fileName)} ></input>
                                                <span class="checkmark"></span>
                                            </label>
                                        </span>
                                        <span className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1">
                                            <img src={desc}></img>
                                        </span>
                                    </span>
                                </div>
                                <div className="pl-1 col-8 col-xl-4 col-md-8 col-lg-5 col-sm-8 my-auto">
                                    <span className="fw-500">{m.fileName}</span>
                                    <div class="progress my-1" style={{ height: "0.3rem" }}>
                                        <div class="progress-bar" id={i+1} role="progressbar" aria-valuenow="100"
                                            aria-valuemin="0" aria-valuemax="100" >
                                            <span class="sr-only">100% Complete</span>
                                        </div>
                                    </div>
                                    <span className="fw-400 f-size-1" id={i+1 + "size"} style={{ fontSize: 10 }}></span>
                                    <span className="float-right fw-500 d-green f-size-1" id={i+1 + "uploading"} style={{ fontSize: 10 }}></span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle || [],
        uploaddocs: state.ShipDocumentReducer.uploaddocs || [],
    };
}

UploadFile.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default (withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UploadFile))
))